"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var composition_api_1 = require("@vue/composition-api");
var helpers_1 = require("../helpers");
var abstractions_1 = require("./abstractions");
exports.default = composition_api_1.defineComponent({
    props: {
        name: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            dafault: ''
        },
        error: {
            type: Object,
            default: null
        },
        placeholder: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        reset: {
            type: String,
            default: ''
        },
        showReset: {
            type: Boolean,
            default: false
        },
        actionSequentialFocus: {
            type: Boolean,
            default: false
        }
    },
    setup: function (props, context) {
        var id = helpers_1.generateRandomId(props.name);
        var textAreaElement = composition_api_1.ref();
        var formattedValue = composition_api_1.computed(function () { return props.value || ''; });
        var onInput = function (evt) {
            if (evt.target instanceof HTMLTextAreaElement) {
                autoExpand(textAreaElement.value);
                context.emit('input', evt.target.value);
            }
        };
        var autoExpand = function (el) {
            // Reset field height
            el.style.height = 'inherit';
            // Get the computed styles for the element
            var computed = window.getComputedStyle(el);
            // Calculate the height
            var height = el.scrollHeight + parseInt(computed.getPropertyValue('border-bottom-width'), 10);
            el.style.height = height + "px";
        };
        var onReset = function () { return context.emit('input', props.reset); };
        composition_api_1.onMounted(function () {
            if (textAreaElement.value) {
                autoExpand(textAreaElement.value);
            }
        });
        return {
            id: id,
            textAreaElement: textAreaElement,
            wrapperClasses: abstractions_1.useWrapperClasses(props, context.attrs),
            inputClasses: abstractions_1.useInputClasses('textarea', composition_api_1.computed(function () { return props.showReset; })),
            formattedValue: formattedValue,
            onInput: onInput,
            onReset: onReset
        };
    }
});
